<template>
    <div>
        <TopAppBar :leftBtnMode="leftBtnMode" :rightBtnMode="rightBtnMode" :title="title" :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod" :hideCategory="false" staticMode="true"></TopAppBar>
        <div class="d-flex flex-column">
            <TopAppBarDrawer></TopAppBarDrawer>
            <main class="main-wrapper flex-grow-1">
                <div class="d-flex align-items-center">
                    <div
                        class="t-headline13 t-color-headlineBlack pda-14 font-m flex-grow-1 bg-white fix-header-title d-flex align-items-center justify-content-center">
                        {{ $t("2011") }}
                    </div>
                </div>
                <div class="divider"></div>
                <div id="tab1" class="container container--small mgt-50">
                    <div class="t-headline5 t-center t-line-27 l-spacing72 font-b">
                        {{ badgeData ? badgeData.name : "" | charLength }}
                    </div>
                    <div class="badge-subtitle" v-if="goals && goals.length > 0" v-html="makeBadgeSubTitle()" />

                    <div class="mgt-24">
                        <img :src="badgeData && badgeData.on && badgeData.on.resourceUri ? badgeData.on.resourceUri : ''" alt="" class="icon210 mgx-auto opacity-08" />
                    </div>
                    <div class="mgt-16">
                        <img src="/images/shadow.svg" alt="" class="icon194 mgx-auto" />
                    </div>
                    <div class="mgt-30 t-body1 l-spacing48 t-line-h-22 t-center t-color-bodyGrayA font-r"
                        v-if="isBadgeDesc()">
                        <div>{{ makeBadgeDesc() }}</div>
                        <div class="t-color-contentsRed" v-if="goals && goals.length > 0">{{ badgeGoalTargetName() }}</div>
                    </div>
                    <div class="mgt-30 t-body1 l-spacing48 t-line-h-22 t-center t-color-bodyGrayA font-r" v-else>
                        <div class="mgt-30 t-body1 l-spacing48 t-line-h-22 t-center t-color-bodyGrayA font-r" v-if="badgeData && badgeData.description">{{ badgeData.description }}</div>
                    </div>
                    <div class="mgt-8 t-body3 t-line-h-22 t-center t-color-bodyGrayA">
                        {{ $moment(badgeData ? badgeData.operating.start : "").format("L") }} ~ {{ badgeEndTime(badgeData.operating.end) }}
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>
<script>
import TopAppBar from "@/components/TopAppBar.vue";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import rewardApi from "@/api/rewardApi.js";
import { dateConstants } from "@/utils/constants/DateConstants";

export default {
    name: "BadgeAvailableDetail",
    data() {
        return {
            title: localStorage.getItem("brandName"),
            leftBtnMethod: () => {
                this.$router.go(-1);
            },
            badgeData: null,
            certificate: null,
            goals: null,
        };
    },
    filters: {
        charLength(value) {
            if (value.length > 30) {
                return value.substring(0, 30) + "..";
            } else {
                return value;
            }
        },
    },
    components: {
        TopAppBar,
        TopAppBarDrawer,
    },

    mixins: [topAppBarMixin],

    mounted() {
        let titleBrand = localStorage.getItem("brandName");
        this.setTopAppBarHomeSearch(titleBrand);
        this.fetchData(this.$route.params.id);
    },

    methods: {
        fetchData(id) {
            rewardApi
                .badgeAchievingDetail({ id })
                .then((response) => {
                    this.badgeData = response.data.data;
                    this.goals = response.data.data.goals;
                })
                .catch((err) => { });
        },

        makeBadgeSubTitle() {
            if (!this.goals || this.goals.length === 0) return "";
            return this.goals.map((goal) => this.makeBadgeStr(goal)).join(", ");
        },

        makeBadgeStr(goal) {
            const badgeNumberStr = `<span class="t-color-lectureRed">${goal.number}</span>`;
            switch (goal.achievementTerms && goal.achievementTerms.value) {
                case "SIGN_IN":
                    return this.$t("3893", { str: badgeNumberStr });

                case "ENROLL_DEGREE":
                    return this.$t("3894", { str: badgeNumberStr });

                case "COMPLETE_DEGREE":
                    return this.$t("3895", { str: badgeNumberStr });

                case "COMPLETE_EXAM":
                    return this.$t("3896", { str: badgeNumberStr });

                case "COMPLETE_SURVEY":
                    return this.$t("3897", { str: badgeNumberStr });

                default:
                    return "";
            }
        },

        isBadgeDesc() {
            if (!this.goals || this.goals.length === 0) return false;
            return [
                "TARGET_COMPLETE_SURVEY_DIST",
                "TARGET_COMPLETE_EXAM_DIST",
                "TARGET_COMPLETE_ONLINE_DEGREE",
            ].includes(this.goals[0].achievementTerms.value);
        },

        badgeGoalTargetName() {
            return `[${this.goals[0].targetName}]`;
        },

        makeBadgeDesc() {
            switch (
            this.goals[0].achievementTerms &&
            this.goals[0].achievementTerms.value
            ) {
                case "TARGET_COMPLETE_ONLINE_DEGREE":
                    return this.$t("3898");

                case "TARGET_COMPLETE_EXAM_DIST":
                    return this.$t("3899");

                case "TARGET_COMPLETE_SURVEY_DIST":
                    return this.$t("3900");

                default:
                    return "";
            }
        },

        badgeEndTime(time) {
           return time >= dateConstants.maximumDate ? this.$t("50013") : this.$moment(time).format("L");
        }
    },
};
</script>
  
<style scoped>
.badge-subtitle {
    font-size: 14px;
    color: var(--bodyGrayA);
    text-align: center;
    margin-top: 8px;
    word-break: keep-all;
}

.opacity-08 {
  opacity: 0.08;
}
</style>